import consumer from './consumer'

consumer.subscriptions.create("CommonChannel", {
  connected() {
    // console.log("Connected to CommonChannel");
  },
  
  disconnected() {
    // console.log("Disconnected from CommonChannel");
  },
  
  received(data) {
    console.log("Received data from CommonChannel:", data);
  }
})